import { useEffect, useState } from "react";
import { useValidateReferralCode } from "@jti/rest-api";
export const useReferralCode = (referralCode) => {
    const [isReferralCodeActive, setIsReferralCodeActive] = useState(false);
    const { data: isValid, reset, isIdle, isLoading, handleCodeValidation } = useValidateReferralCode(referralCode);
    const handleToggleIsReferralCodeActive = () => {
        setIsReferralCodeActive((isActive) => !isActive);
    };
    useEffect(() => {
        reset();
    }, [referralCode]);
    useEffect(() => {
        if (referralCode) {
            setIsReferralCodeActive(true);
        }
    }, []);
    return {
        isIdle,
        isValid,
        isPending: isLoading,
        isReferralCodeActive,
        handleCodeValidation,
        handleToggleIsReferralCodeActive,
    };
};
//# sourceMappingURL=useReferralCode.js.map